export default "__VITE_ASSET__CgkDFu1V__"